Backbone.mixin = function(view, mixin) {
  _.defaults(view.prototype, mixin);
  _.defaults(view.prototype.events, mixin.events);

  return view;
};
